import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section
      aria-labelledby="testimonials-heading"
      className="w-full border-b border-background-200 bg-background-50"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Readers"
          id="testimonials-heading"
          title="读者怎么说"
          desc="我们最常收到的反馈不是「说得对」，而是「终于看懂了顺序」。这大概是对一份结构梳理最好的评价。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 70}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-6">
                <i className="ri-double-quotes-l text-2xl text-accent-400" aria-hidden="true" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-6 border-t border-background-200 pt-4">
                  <span className="block font-heading text-sm font-bold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="mt-1 block text-xs text-foreground-500">
                    {item.identity}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}